import { usePortletConfig } from 'js/components/system/Portlet';

export const useParams = () => {
    const { casino, bingo, sportsbook, poker } = usePortletConfig();

    return { casino, bingo, sportsbook, poker };
};
